import apiService from "./Api";

export interface RoleResponse {
  id: number;
  name: string;
  permissions: number[];
  is_managed?: boolean;
  user_count?: number;
}

export interface PaginatedRoleResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: RoleResponse[];
}

class RoleService {
  private readonly BASE_PATH = "/api/authentication/groups";

  async getRoles(params?: { page?: number; page_size?: number }) {
    const response = await apiService.get<PaginatedRoleResponse>(
      `${this.BASE_PATH}/`,
      params
    );
    return response.data;
  }

  async getRole(id: number): Promise<RoleResponse> {
    const response = await apiService.get<RoleResponse>(
      `${this.BASE_PATH}/${id}/`
    );
    return response.data;
  }

  async getAllRoles(): Promise<RoleResponse[]> {
    const allRoles: RoleResponse[] = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await this.getRoles({ page, page_size: 100 });
      allRoles.push(...response.results);
      hasMore = response.next !== null;
      page++;
    }

    return allRoles;
  }

  async createRole(data: { name: string }): Promise<RoleResponse> {
    const response = await apiService.post<RoleResponse>(
      `${this.BASE_PATH}/`,
      data
    );
    return response.data;
  }

  async updateRole(id: number, data: Partial<RoleResponse>): Promise<RoleResponse> {
    const response = await apiService.patch<RoleResponse>(
      `${this.BASE_PATH}/${id}/`,
      data
    );
    return response.data;
  }

  async deleteRole(id: number): Promise<void> {
    await apiService.delete(`${this.BASE_PATH}/${id}/`);
  }
}

const roleService = new RoleService();
export default roleService;